export default "__VITE_ASSET__DLgTWF3K__"